// Client-side event telemetry.
// Batched: buffers events for up to 5s or 20 events, whichever comes
// first. Flushes on `beforeunload` so nothing is lost when a user
// closes the tab. All writes go to POST /api/usage/track and are
// silently ignored by the server if the payload is malformed.
import { api } from './api';

const MAX_BUFFER = 20;
const FLUSH_INTERVAL_MS = 5000;

let buffer = [];
let flushTimer = null;

function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = setTimeout(flush, FLUSH_INTERVAL_MS);
}

async function flush() {
  if (flushTimer) {
    clearTimeout(flushTimer);
    flushTimer = null;
  }
  if (buffer.length === 0) return;
  const toSend = buffer.splice(0, buffer.length);
  // Fire each independently so one bad event never blocks the batch.
  for (const evt of toSend) {
    try {
      await api.trackEvent(evt);
    } catch (_) {
      // never surface telemetry errors to the user
    }
  }
}

export function trackEvent(eventType, objectType = null, objectId = null, metadata = null, objectName = null) {
  if (!eventType) return;
  const evt = {
    event_type: eventType,
    object_type: objectType,
    object_id: objectId,
    object_name: objectName,
    metadata: metadata || {},
  };
  buffer.push(evt);
  if (buffer.length >= MAX_BUFFER) {
    flush();
  } else {
    scheduleFlush();
  }
}

export function trackPageView(pagePath) {
  if (!pagePath) return;
  trackEvent('page_view', 'page', pagePath, { path: pagePath });
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    // Best-effort synchronous send on unload.
    if (buffer.length && navigator.sendBeacon) {
      try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
        for (const evt of buffer) {
          const blob = new Blob([JSON.stringify(evt)], { type: 'application/json' });
          navigator.sendBeacon(`${BACKEND_URL}/api/usage/track`, blob);
        }
        buffer = [];
      } catch (_) { /* best-effort only */ }
    }
  });
}
